function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1075_13194)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.000175476 0.474956L98.9047 0.475269C100.19 0.412709 101.448 0.841338 102.403 1.66703C103.359 2.49272 103.933 3.64797 104 4.87909V18.0714C103.933 19.3025 103.359 20.4578 102.403 21.2835C101.448 22.1092 100.19 22.5378 98.9047 22.4752H0.000175476V0.474956Z",
  fill: "url(#paint0_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.283 5.97604L8.55729 9.29527L4.73485 9.84551L7.49963 12.4192L6.85018 16.0757L10.283 14.354L13.7157 16.0757L13.0663 12.4192L15.8311 9.84551L11.9901 9.29527L10.283 5.97604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2451 11.4785L8.53799 9.29527L10.2451 5.97604V11.4785Z",
  fill: "url(#paint1_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3197 5.97604L12.0269 9.29527L10.3197 11.4785V5.97604Z",
  fill: "url(#paint2_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3381 11.496L11.971 9.25952L15.812 9.79202L10.3381 11.496Z",
  fill: "url(#paint3_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.8311 9.86371L13.0663 12.4374L10.3572 11.5677L15.8311 9.86371Z",
  fill: "url(#paint4_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.3377 11.5853L13.0654 12.384L13.7334 16.0405L10.3377 11.5853Z",
  fill: "url(#paint5_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6787 16.076L10.2459 14.3543L10.283 11.6208L13.6787 16.076Z",
  fill: "url(#paint6_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2637 11.6208L10.3193 14.3543L6.88655 16.076L10.2637 11.6208Z",
  fill: "url(#paint7_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.8309 16.0405L7.48034 12.384L10.208 11.5853L6.8309 16.0405Z",
  fill: "url(#paint8_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.208 11.5499L7.49889 12.4374L4.7341 9.86371L10.208 11.5499Z",
  fill: "url(#paint9_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.75267 9.79202L8.57512 9.25952L10.2266 11.496L4.75267 9.79202Z",
  fill: "url(#paint10_linear_1075_13194)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.1152 15.1073C47.5082 12.7424 46.8876 10.9705 46.2292 9.526L45.0157 10.081C45.6854 11.3975 45.9811 12.8725 45.8707 14.3455H43.6781C43.2575 14.3455 42.7439 14.2455 42.1509 13.5112L41.1167 14.3455C41.851 15.2487 42.668 15.6727 43.685 15.6727H47.029L47.1152 15.1073Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.4557 10.1052C50.4557 10.1293 51.6105 12.4081 50.8004 14.4179C50.3143 15.6072 49.2111 16.4863 47.5288 17.062L47.9563 18.3203C50.0247 17.6309 51.4037 16.476 52.0415 14.9074C53.0757 12.3322 51.7036 9.61566 51.6312 9.51913L50.4557 10.1052Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.1786 12.6459C55.1786 12.3096 55.2784 11.9809 55.4653 11.7013C55.6522 11.4217 55.9179 11.2039 56.2286 11.0754C56.5394 10.9468 56.8813 10.9134 57.2111 10.9792C57.5408 11.0451 57.8437 11.2073 58.0812 11.4453C58.3188 11.6834 58.4804 11.9865 58.5455 12.3164C58.6107 12.6463 58.5766 12.9882 58.4474 13.2987C58.3183 13.6092 58.0999 13.8744 57.8199 14.0607C57.54 14.247 57.2111 14.3461 56.8748 14.3454C56.4261 14.3455 55.9957 14.1677 55.6779 13.8511C55.36 13.5345 55.1805 13.1049 55.1786 12.6562V12.6459ZM56.8748 9.63974C56.1111 9.66819 55.3868 9.98539 54.848 10.5273C54.3092 11.0692 53.9962 11.7953 53.9721 12.5591C53.948 13.3229 54.2147 14.0673 54.7183 14.6421C55.2219 15.2168 55.9248 15.579 56.6852 15.6555C55.7628 16.2646 54.7573 16.7372 53.6997 17.0586L54.1203 18.3203C59.8154 16.4553 59.9326 13.3595 59.905 12.7838C59.905 12.7355 59.905 12.6907 59.905 12.6459C59.9023 11.8437 59.5812 11.0754 59.0124 10.5098C58.4436 9.94424 57.6735 9.62757 56.8713 9.6294",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.3685 7.7955C93.51 7.79617 93.6485 7.75494 93.7667 7.67701C93.8848 7.59908 93.9773 7.48794 94.0323 7.35758C94.0874 7.22722 94.1027 7.08347 94.0763 6.94444C94.0498 6.80541 93.9828 6.67731 93.8837 6.57629C93.7846 6.47526 93.6578 6.40582 93.5193 6.37672C93.3808 6.34761 93.2368 6.36014 93.1054 6.41273C92.974 6.46531 92.8611 6.5556 92.7809 6.67223C92.7008 6.78885 92.6569 6.92659 92.6549 7.0681C92.6535 7.16284 92.6709 7.25692 92.7061 7.34489C92.7413 7.43285 92.7936 7.51297 92.86 7.58061C92.9263 7.64825 93.0054 7.70207 93.0927 7.73895C93.18 7.77584 93.2737 7.79506 93.3685 7.7955Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.3686 12.2116C93.1091 12.2103 92.8559 12.1321 92.6408 11.9869C92.4257 11.8418 92.2584 11.6362 92.16 11.396C92.0617 11.1559 92.0367 10.892 92.0881 10.6377C92.1396 10.3834 92.2652 10.15 92.4492 9.96699C92.6331 9.78399 92.8672 9.65958 93.1218 9.60945C93.3764 9.55933 93.6401 9.58574 93.8797 9.68535C94.1193 9.78496 94.324 9.95331 94.4681 10.1692C94.6121 10.385 94.689 10.6387 94.689 10.8982C94.6871 11.2471 94.5472 11.5812 94.2998 11.8273C94.0524 12.0735 93.7176 12.2116 93.3686 12.2116ZM95.9955 10.8982C96 10.3194 95.8137 9.75525 95.4654 9.29298C95.1171 8.8307 94.6262 8.49603 94.0687 8.34068C93.5111 8.18534 92.9179 8.21798 92.3808 8.43356C91.8436 8.64915 91.3925 9.03566 91.097 9.53336C90.8015 10.0311 90.6782 10.6122 90.7462 11.187C90.8141 11.7618 91.0695 12.2982 91.4728 12.7133C91.8762 13.1284 92.405 13.3991 92.9776 13.4835C93.5502 13.5679 94.1347 13.4614 94.6407 13.1803C94.5547 13.5199 94.3577 13.821 94.081 14.0359C93.8043 14.2507 93.4638 14.367 93.1135 14.3662H67.8544C68.1636 13.9016 68.3279 13.3557 68.3267 12.7977V6.32001H67.0201V12.7977C67.0197 13.0041 66.9785 13.2084 66.8991 13.399C66.8197 13.5895 66.7035 13.7626 66.5572 13.9082C66.4109 14.0539 66.2374 14.1693 66.0465 14.2479C65.8556 14.3265 65.6511 14.3667 65.4446 14.3662H64.2932C64.4611 13.4303 64.4006 12.4677 64.1167 11.5602C63.8328 10.6527 63.334 9.82714 62.6626 9.15377L61.7352 10.0708C62.2868 10.6242 62.6886 11.3088 62.9027 12.0602C63.1168 12.8117 63.1362 13.6052 62.9591 14.3662H60.8906V15.6659H93.3445C94.0649 15.6097 94.7378 15.2845 95.2295 14.7551C95.7213 14.2256 95.996 13.5306 95.999 12.808V10.9947C95.999 10.9602 95.999 10.9292 95.999 10.8982",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.9278 17L21 8H22.8648L25.0094 14.9275L27.1352 8H29L26.0537 17H23.9278Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 8H32V17H30V8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.1274 8.00076C36.5055 7.99174 36.8816 8.06348 37.2335 8.21175C37.5853 8.36003 37.9059 8.58186 38.1764 8.86422C38.7044 9.44136 39 10.2161 39 11.0229C39 11.8297 38.7044 12.6044 38.1764 13.1816C37.9059 13.4639 37.5853 13.6858 37.2335 13.834C36.8816 13.9823 36.5055 14.054 36.1274 14.045H34.6355V17H33V8.00076H36.1274ZM36.1274 12.3948C36.2925 12.398 36.4564 12.3637 36.6082 12.2942C36.76 12.2247 36.8963 12.1217 37.008 11.9919C37.1233 11.8614 37.2129 11.7076 37.2715 11.5395C37.3302 11.3714 37.3567 11.1925 37.3495 11.0133C37.36 10.652 37.2374 10.3006 37.008 10.0347C36.8927 9.91114 36.7554 9.81351 36.6041 9.7476C36.4529 9.68168 36.2907 9.64881 36.1274 9.65094H34.6355V12.3948H36.1274Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1075_13194",
  x1: 104,
  y1: 11.4657,
  x2: -5.19985,
  y2: 11.4657,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1D222A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#262D39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#39435A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1075_13194",
  x1: 10.2451,
  y1: 8.72727,
  x2: 8.53799,
  y2: 8.72727,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFFF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#FCF7DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#F8E3A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3C34E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1B932"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1075_13194",
  x1: 11.1733,
  y1: 11.4963,
  x2: 11.1733,
  y2: 5.97604,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#5F3618"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#DCA24E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#E5C466"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#EBDC77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#EDE57D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1075_13194",
  x1: 13.0658,
  y1: 10.6618,
  x2: 12.5866,
  y2: 9.08748,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDE579"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#EBD672"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#E6B964"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#E2B561"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#D8A959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#C6954B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#AD7937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A57031"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1075_13194",
  x1: 12.5282,
  y1: 12.2777,
  x2: 13.5732,
  y2: 9.08975,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#B9873C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1075_13194",
  x1: 11.5438,
  y1: 14.3898,
  x2: 13.0715,
  y2: 12.3889,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_1075_13194",
  x1: 9.80059,
  y1: 13.2538,
  x2: 14.1309,
  y2: 14.5444,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_1075_13194",
  x1: -150.301,
  y1: 41.4262,
  x2: -147.041,
  y2: 46.489,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_1075_13194",
  x1: 8.90912,
  y1: 11.39,
  x2: 7.87135,
  y2: 18.4329,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#AA7534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#DCA24E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_1075_13194",
  x1: 7.55455,
  y1: 10.5205,
  x2: 6.90156,
  y2: 12.2091,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_1075_13194",
  x1: 5.40212,
  y1: 11.425,
  x2: 9.5273,
  y2: 9.75753,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEAC1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#EFB534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#F3CD6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F9F3C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBFFE1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1075_13194"
}, /*#__PURE__*/React.createElement("rect", {
  width: 104,
  height: 22,
  rx: 3,
  transform: "matrix(-1 0 0 1 104 0.476044)",
  fill: "white"
})));

function SvgFlowardVipLgAr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 23,
    viewBox: "0 0 104 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowardVipLgAr);
export default __webpack_public_path__ + "static/media/floward-vip-lg-ar.8cfddf88.svg";
export { ForwardRef as ReactComponent };